<div
  class="page-container training-landing-container container unified training"
>
  <app-training-nav
    class="full-height"
    [mode]="currentMode"
    [currentTab]="currentTab"
    (tabChange)="tabChange($event)"
  />

  <div class="content">
    @if (settings && !loading) {
      @if (currentTab === 'landing') {
        <app-training-section
          [section]="'landing'"
          [settings]="settings"
          [loadedVideo]="loadedVideo"
          (videoChange)="tabChange($event)"
        />
      } @else {
        @for (section of settings.content; track $index) {
          @if (section.app === currentTab) {
            <app-training-section
              [section]="section.app"
              [settings]="settings"
              [loadedVideo]="loadedVideo"
              (videoChange)="tabChange($event)"
            />
          }
        }
      }
    }
  </div>
</div>
<ngx-loading [show]="loading" />
